<template>
  <div class="container">
    <v-form v-model="$storeDemandeBourse.ValidInfosPerso" ref="refInfosPersos" lazy-validation>
      <v-dialog v-model="dialog.photo" max-width="80%">
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title> Ajouter une photo </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap xs12>
                <v-flex xs4> </v-flex>
                <v-flex xs8>
                  <!--cutom update button AGU-->
                  <upload-btn class="mr-10" color="secondary" :loading="uploadFileLoading" :selectedFileName="$storeDemandeBourse.DonneesFormulaire.Photo.NomFichier
                    " defaultButtonText="Sélectionner votre document" @file-update="selectFile">
                  </upload-btn>
                  <small>Formats acceptés : images (jpg, jpeg et png)</small>
                </v-flex>
                <v-flex xs5 text-xs-center> </v-flex>
              </v-layout>
              <v-layout row wrap xs12>
                <span v-if="$storeDemandeBourse.DonneesFormulaire.Photo">Fichier Sélectionné :
                </span>
                <span v-if="$storeDemandeBourse.DonneesFormulaire.Photo" style="background-color: lightgray">{{
                  $storeDemandeBourse.DonneesFormulaire.Photo.NomFichier
                }}</span>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" dark @click="close">Annuler</v-btn>
            <v-btn color="success" dark :loading="uploadFileLoading" @click="save">Valider</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <img id="image" 
          :src="$storeDemandeBourse.DonneesFormulaire.Photo.LienSecurisePj" 
          width="250" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <v-btn color="secondary" dark @click="editItem" v-show="!$storeDemandeBourse.ReadOnly">Ajouter une photo</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field label="Nom" v-model="$storeDemandeBourse.DonneesFormulaire.Nom"
            :rules="$storeReglesBourse.obligatoire" ref="nom" :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field label="Prenom" v-model="$storeDemandeBourse.DonneesFormulaire.Prenom"
            :rules="$storeReglesBourse.obligatoire" ref="prenom" :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field label="N° pièce identité" v-model="$storeDemandeBourse.DonneesFormulaire.Cni"
            :rules="$storeReglesBourse.obligatoire" ref="cni" readonly disabled></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field label="CNE" v-model="$storeDemandeBourse.DonneesFormulaire.Cne"
            :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete 
          label="Genre" 
          v-model="$storeDemandeBourse.DonneesFormulaire.Genre" 
          item-text="lang00"
          item-value="id" 
          :items="$storeCatalogue.Genre" 
          :clearable="!$storeDemandeBourse.ReadOnly"
          :rules="$storeReglesBourse.obligatoire" 
          ref="genre" 
          :readonly="$storeDemandeBourse.ReadOnly"
          ></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-menu 
          v-model="menu.dateNaissance" 
          :disabled="$storeDemandeBourse.ReadOnly" 
          :close-on-content-click="false"
          :nudge-right="40" 
          transition="scale-transition" 
          :clearable="!$storeCatalogue.ReadOnly" 
          offset-y
            min-width="auto">
            <template #activator="{ on, attrs }">
              <v-text-field 
              :clearable="!$storeCatalogue.ReadOnly" 
              v-model="DateNaissanceFormated" 
              label="Date de naissance"
              :rules="$storeReglesBourse.obligatoire"
              prepend-icon="mdi-calendar" 
              ref="datenaissance"
              readonly v-bind="attrs" 
              :disabled="$storeDemandeBourse.ReadOnly" v-on="on"
              @click:clear="
                  $storeDemandeBourse.DonneesFormulaire.DateNaissance = null
                  " />
            </template>
            <v-date-picker 
            v-model="$storeDemandeBourse.DonneesFormulaire.DateNaissance" 
              :max="MaxDateNaissance"
              itemprop="Date de naissance"
              :clearable="!$storeDemandeBourse.ReadOnly"
              :disabled="$storeDemandeBourse.ReadOnly" 
              @input="menu.dateNaissance = false" />
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Nationalité" v-model="$storeDemandeBourse.DonneesFormulaire.Nationalite" item-text="lang00"
            item-value="id" :items="$storeCatalogue.Pays" :clearable="!$storeDemandeBourse.ReadOnly"
            :rules="$storeReglesBourse.obligatoire" ref="nationalite" :readonly="$storeDemandeBourse.ReadOnly"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-autocomplete label="Autre nationalié" 
          v-model="$storeDemandeBourse.DonneesFormulaire.AutreNationalite"
            item-text="lang00" 
            item-value="id" 
            :items="$storeCatalogue.Pays" 
            :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field label="Email" v-model="$storeDemandeBourse.DonneesFormulaire.Email"
            :rules="$storeReglesBourse.emailObligatoire" ref="email" :readonly="$storeDemandeBourse.ReadOnly"
            @change="onEmailChange"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field label="Tel Maroc" 
          v-model="$storeDemandeBourse.DonneesFormulaire.TelMaroc"
          :rules="$storeReglesBourse.obligatoire"
          :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6"> </v-col>
        <v-col cols="6">
          <v-text-field label="Tel France" v-model="$storeDemandeBourse.DonneesFormulaire.TelFrance"
            :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-subheader>Adresse au Maroc</v-subheader>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="6">
          <v-autocomplete 
          label="Pays" 
          v-model="$storeDemandeBourse.DonneesFormulaire.PaysAdrPrincipale" 
          item-text="lang00"
            item-value="id" 
            :items="$storeCatalogue.Pays" 
            :rules="$storeReglesBourse.obligatoire"
            readonly 
            disabled></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field label="Adresse" v-model="$storeDemandeBourse.DonneesFormulaire.AdrPrincipale"
            :rules="$storeReglesBourse.obligatoire" ref="adresse" :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field label="Code postal" v-model="$storeDemandeBourse.DonneesFormulaire.CodePostalAdrPrincipale
          " :rules="$storeReglesBourse.obligatoireLengthDix" ref="cp" :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field label="Ville" v-model="$storeDemandeBourse.DonneesFormulaire.VilleAdrPrincipale"
            :rules="$storeReglesBourse.obligatoire" ref="ville" :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Province" 
          v-model="$storeDemandeBourse.DonneesFormulaire.ProvinceMaroc" 
          item-text="lang00"
            item-value="id" 
            :items="$storeCatalogue.Province" 
            :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly" 
            :rules="$storeReglesBourse.obligatoire"
            @change="provinceChange"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-autocomplete 
          label="Région" 
          v-model="$storeDemandeBourse.DonneesFormulaire.RegionMaroc" 
          item-text="lang00"
            item-value="id" 
            :items="$storeCatalogue.Region" 
            readonly disabled></v-autocomplete>
        </v-col>
      </v-row>
      <v-subheader>Autre adresse</v-subheader>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Pays" v-model="$storeDemandeBourse.DonneesFormulaire.PaysAutreAdresse" item-text="lang00"
            item-value="id" :items="$storeCatalogue.Pays" :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly" @change="PaysAutreAdresseChange"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field label="Adresse" 
          v-model="$storeDemandeBourse.DonneesFormulaire.AutreAdresse"
            :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field label="Code postal" 
          v-model="$storeDemandeBourse.DonneesFormulaire.CodePostalAutreAdresse"
          ref="cpautre" 
          :rules="$storeReglesBourse.LengthDix"
          :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field 
          label="Ville" 
          v-model="$storeDemandeBourse.DonneesFormulaire.VilleAutreAdresse"
          ref="villeautre" 
          :readonly="$storeDemandeBourse.ReadOnly"></v-text-field>
        </v-col>
      </v-row>
      <v-row v-show="showFrance">
        <v-col cols="6">
          <v-autocomplete 
          label="Departement" 
          v-model="$storeDemandeBourse.DonneesFormulaire.DepartementFrance"
            item-text="lang00" item-value="id" :items="$storeCatalogue.DepartementFrance"
            :clearable="!$storeDemandeBourse.ReadOnly" :readonly="$storeDemandeBourse.ReadOnly"
            @change="departementChange"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-autocomplete label="Région" v-model="$storeDemandeBourse.DonneesFormulaire.RegionFrance" item-text="lang00"
            item-value="id" :items="$storeCatalogue.RegionFrance" disabled readonly></v-autocomplete>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-spacer></v-spacer>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Etes-vous en situation de handicap ?"
            v-model="$storeDemandeBourse.DonneesFormulaire.SituationHandicap" item-text="lang00" item-value="id"
            :items="$storeCatalogue.OuiNon" :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly" :rules="$storeReglesBourse.obligatoire"
            ref="situationhandicap"
            @change="SituationHandicapChange"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-autocomplete 
          v-show="$storeDemandeBourse.DonneesFormulaire.SituationHandicap ==$storeCatalogue.DataId.Oui" 
          label="Type de handicap" 
          v-model="$storeDemandeBourse.DonneesFormulaire.TypeHandicap" 
            item-text="lang00"
            item-value="id" 
            :items="$storeCatalogue.NatureHandicap" 
            :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly" 
            ref="typehandicap"
            :rules="$storeDemandeBourse.DonneesFormulaire.SituationHandicap ==$storeCatalogue.DataId.Oui ? $storeReglesBourse.obligatoire : []"
            multiple></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Provenez-vous d'un établissement de protection sociale ?"
            v-model="$storeDemandeBourse.DonneesFormulaire.ProtectionSociale" item-text="lang00" item-value="id"
            :items="$storeCatalogue.OuiNon" :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly" 
            :rules="$storeReglesBourse.obligatoire"
            ref="protectionsociale"
            @change="ProtectionSocialeChange"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field 
          v-show="$storeDemandeBourse.DonneesFormulaire.ProtectionSociale == $storeCatalogue.DataId.Oui" 
            label="Nom de l'établissement de protection social" 
            :readonly="$storeDemandeBourse.ReadOnly" 
            v-model="$storeDemandeBourse.DonneesFormulaire.EtablissementProtectionSociale"
            ref="nometab"
            :rules="$storeDemandeBourse.DonneesFormulaire.ProtectionSociale == $storeCatalogue.DataId.Oui ? $storeReglesBourse.obligatoire : []"></v-text-field>
        </v-col>
        <small>
          Les établissements de protection sociale sont des structures d’accueil
          dont le rôle est d’assister et de protéger les personnes en situation de
          précarité ou dans le besoin (exemple : Orphelinat, SOS Villages
          d’Enfants, Dar Atfal- …)</small>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Disposez-vous d'un régime de protection sociale ?"
            v-model="$storeCommun.InfosCandidature.RegimeProtectionSociale" item-text="lang00" item-value="id"
            :items="$storeCatalogue.OuiNon" :clearable="!$storeDemandeBourse.ReadOnly"
            :readonly="$storeDemandeBourse.ReadOnly" 
            :rules="$storeReglesBourse.obligatoire"
            ref="regimeprotection"
            ></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field 
          v-show="$storeCommun.InfosCandidature.RegimeProtectionSociale == $storeCatalogue.DataId.Oui" 
            label="Précisez le nom de l'organisme" 
            :readonly="$storeDemandeBourse.ReadOnly" 
            v-model="$storeCommun.InfosCandidature.NomOrganisme"
            ref="preciseznomorga"
            :rules="$storeCommun.InfosCandidature.RegimeProtectionSociale == $storeCatalogue.DataId.Oui ? $storeReglesBourse.obligatoire : []"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Comment avez-vous connu la FIRSI ?"
            v-model="$storeCommun.InfosCandidature.ConnaissanceFirsi" 
            item-text="lang00" 
            item-value="id"
            :items="$storeCatalogue.ConnaissanceFirsi" 
            :readonly="$storeDemandeBourse.ReadOnly"
            :rules="$storeReglesBourse.obligatoire"
            ref="connufirsi"></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-text-field 
          v-show="$storeCommun.InfosCandidature.ConnaissanceFirsi == $storeCatalogue.DataId.ConnaissanceFirsiAutre" 
            label="Préciser" 
            :readonly="$storeDemandeBourse.ReadOnly" 
            v-model="$storeCommun.InfosCandidature.PreciserConnaissance"
            ref="preciserConnaissanceFir"
            :rules="$storeCommun.InfosCandidature.ConnaissanceFirsi == $storeCatalogue.DataId.ConnaissanceFirsiAutre ? $storeReglesBourse.obligatoire : []"></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-alert border="left" colored-border color="secondary" elevation="1">
        Situation financière et professionnelle du candidat
      </v-alert>
      <v-row>
        <v-col cols="6">
          <v-autocomplete 
          label="Etes vous ?" 
          v-model="$storeCommun.InfosCandidature.EtesVous" 
          item-text="lang00" 
          item-value="id" 
          :items="$storeCatalogue.EtesVous"
          :readonly="$storeDemandeBourse.ReadOnly"
          :rules="$storeReglesBourse.obligatoire"
          ref="etesvous"
          ></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-autocomplete 
          label="Si à la charge d'un de mes deux parents, divorcé(e) ou veuf (ve)" 
          v-model="$storeCommun.InfosCandidature.ChargeUnParent" 
          item-text="lang00" 
          item-value="id" 
          :items="$storeCatalogue.ChargeParent"
          :readonly="$storeDemandeBourse.ReadOnly" 
          v-show="
            $storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentDivorce 
            || $storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentVeuf"
          :rules="$storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentDivorce 
            || $storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentVeuf
            ? $storeReglesBourse.obligatoire:[]"
            ref="chargeunparent"
              ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-autocomplete label="Parent tuteur divorcée" 
          v-model="$storeCommun.InfosCandidature.ParentTuteurDivorceMultiple" 
          item-text="lang00" 
          item-value="id" 
          :items="$storeCatalogue.SituationParent"
          :readonly="$storeDemandeBourse.ReadOnly" 
          multiple 
          v-show="$storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentDivorce"
          :rules="$storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentDivorce 
            ? $storeReglesBourse.obligatoire:[]"
            ref="tuteurdivorce"
          ></v-autocomplete>

          <v-autocomplete label="Parent tuteur veuf" 
          v-model="$storeCommun.InfosCandidature.ParentVeuf" 
          item-text="lang00" 
          item-value="id"
          :items="$storeCatalogue.SituationParent"
          :readonly="$storeDemandeBourse.ReadOnly" 
          v-show="$storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentVeuf"
          :rules="$storeCommun.InfosCandidature.EtesVous === $storeCatalogue.DataId.ChargeUnParentVeuf 
            ? $storeReglesBourse.obligatoire:[]"
            ref="tuteurveuf"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-subheader>Situation financière et professionnelle du candidat </v-subheader>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="6">
          <v-autocomplete 
          label="Vous êtes ? *" 
          v-model="$storeCommun.InfosCandidature.VousEtes" 
          item-text="lang00" item-value="id" :items="$storeCatalogue.VousEtes"
            :readonly="$storeDemandeBourse.ReadOnly"
            :rules="$storeReglesBourse.obligatoire"
            ref="vousetes"
            ></v-autocomplete>
        </v-col>
        <v-col cols="6">
          <VuetifyMoney 
          v-model="$storeCommun.InfosCandidature.RevenuNetMensuel" 
          label="Revenu net Mensuel *" 
          v-bind:readonly="$storeDemandeBourse.ReadOnly" 
          v-bind:disabled="disabled"
          v-bind:outlined="outlined" 
          v-bind:clearable="clearable" 
          v-bind:options="optionsDH" 
          v-show="$storeCommun.InfosCandidature.VousEtes &&
              $storeCommun.InfosCandidature.VousEtes !==
              $storeCatalogue.DataId.VousEtesEtudiant" 
          :rules="$storeCommun.InfosCandidature.VousEtes &&
              $storeCommun.InfosCandidature.VousEtes !==
              $storeCatalogue.DataId.VousEtesEtudiant
              ? $storeReglesBourse.obligatoire : []"
              ref="revenu"
              />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <template>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                v-bind="attrs"
                v-on="on" 
                label="Nombre de compte bancaire" 
                v-model="$storeCommun.InfosCandidature.NbCompteBancaire" 
                item-text="lang00" 
                item-value="id"
                :items="$storeCatalogue.NbCompteBancaire" 
                clearable 
                :rules="$storeReglesBourse.obligatoire"
                ref="nbcomptebancaire"
                :readonly="$storeDemandeBourse.ReadOnly"
                ></v-autocomplete>
              </template>
              <span>En cas d’absence de compte bancaire veuillez télécharger l’attestation 
              de la centrale des comptes délivrée par Bank Al Maghreb</span>
            </v-tooltip>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
          v-if="$storeDemandeBourse.DonneesFormulaire.Lydexien === true"
          label="Numéro de compte marocain" 
          v-model="$storeCommun.InfosCandidature.NumCompteMarocain" 
          :rules="$storeReglesBourse.CompteMarocain"
          ref="numCompteMarocain"
          :readonly="$storeDemandeBourse.ReadOnly"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <v-autocomplete 
          label="Actuellement, bénéficiez-vous d'une autre bourse ?" 
          v-model="$storeDemandeBourse.DonneesFormulaire.BeneficiaireAutreBourse"
          item-text="lang00"
          item-value="id"
          :items="$storeCatalogue.OuiNon"
          :clearable="!$storeDemandeBourse.ReadOnly"
          :readonly="$storeDemandeBourse.ReadOnly"
          :rules="$storeReglesBourse.obligatoire"
          @change="$storeCommun.QuestionTableau(
            $storeDemandeBourse.DonneesFormulaire.BeneficiaireAutreBourse,
            $storeCommun.ListeAutresBourses,
            {}
          )"
          ref="autrebourse"/>
        </v-col> 
        <v-col cols="4">
        </v-col> 
      </v-row>
    <!-- autres revenus -->
    </v-form>
    <v-dialog v-model="dialogEmailChange.model" width="500">
      <v-card>
        <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
        <v-card-text>
          <p>{{ $storeUm6p.Label.AdressePrincipaleCompte }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogEmailChange.model = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import UploadButton from "@/components/CustomFileUpload";
import VuetifyMoney from "../VuetifyMoney";
import { mdiPlusThick, mdiDelete } from "@mdi/js";
export default {
  name: "InformationsPersonnelles",
  components: {
    "upload-btn": UploadButton,
    VuetifyMoney,
  },
  computed: {
    DateNaissanceFormated() {
      return this.formatDate(
        this.$storeDemandeBourse.DonneesFormulaire.DateNaissance
      );
    },
    MinDateNaissance() {
      return moment(String(new Date()))
        .subtract(30, "year")
        .format("YYYY-MM-DD");
      // à ajouter comme ça dans le champ date :min="MinDateNaissance"
      // commenter pour le moment, le client va surement revenir dessus
    },
    MaxDateNaissance() {
      return moment(String(new Date()))
        .subtract(15, "year")
        .format("YYYY-MM-DD");
    },
  },
  mounted(){
    this.$refs.refInfosPersos.resetValidation();
  },
  methods: {
    ValiderForm(){
      this.$refs.refInfosPersos.validate();
      let listeErreur =[];
       Object.keys(this.$refs).forEach(key => {
        if(key != "refInfosPersos"){
          if((!this.$refs[key].valid && this.$refs[key].valid != undefined)
          || (this.$refs[key].valid == undefined
          && this.$refs[key].$children != undefined
          && this.$refs[key].$children[0] != undefined 
          && !this.$refs[key].$children[0].valid)){
            let label = this.$refs[key].label;
            if(!label){
              let inp = this.$refs[key];
              if(!inp.$attrs){
                inp = inp[0];
              }
              label = inp.$attrs["itemprop"];
            }
            listeErreur.push(label);
          }
        }
      });
      return listeErreur;
    },
    SituationHandicapChange(){
      if(this.$storeDemandeBourse.DonneesFormulaire.SituationHandicap === this.$storeCatalogue.DataId.Non){
        this.$storeDemandeBourse.DonneesFormulaire.TypeHandicap = [];
      }
    },
    ProtectionSocialeChange() {
      if (
        this.$storeDemandeBourse.DonneesFormulaire.ProtectionSociale ==
        this.$storeCatalogue.DataId.Oui
      ) {
        this.$storeDemandeBourse.Headers =
          this.$storeDemandeBourse.HeadersProtection;
      } else {
        this.$storeDemandeBourse.Headers =
          this.$storeDemandeBourse.HeadersPasProtection;
      }
    },
    PaysAutreAdresseChange() {
      this.showFrance =
        this.$storeDemandeBourse.DonneesFormulaire.PaysAutreAdresse ==
        this.$storeCatalogue.DataId.France;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        this.uploadFileLoading = true;
        this.$storeDemandeBourse.DonneesFormulaire.Photo.NomFichier = file.name;
        await this.readFile(
          file,
          this.$storeDemandeBourse.DonneesFormulaire.Photo
        );
        setTimeout(this.stopLoadinMode, 2000);
        if (
          file.name.endsWith("jpg") ||
          file.name.endsWith("jpeg") ||
          file.name.endsWith("png")
        ) {
          this.$storeDemandeBourse.DonneesFormulaire.Photo.LienSecurisePj =
            URL.createObjectURL(file);
        } else {
          alert("Format non supporté. Autorisé : jpg, jpeg et png");
          this.$storeDemandeBourse.DonneesFormulaire.Photo.LienSecurisePj = "";
          this.$storeDemandeBourse.DonneesFormulaire.Photo.NomFichier = "";
          this.$storeDemandeBourse.DonneesFormulaire.Photo.DonneePieceJointe =
            null;
        }
      } else {
        this.$storeDemandeBourse.DonneesFormulaire.Photo.NomFichier = "";
        this.$storeDemandeBourse.DonneesFormulaire.Photo.DonneePieceJointe =
          null;
      }
    },
    save() {
      // Si aucun fichier n'est sélectionné, on ne valide rien
      if (!this.$storeDemandeBourse.DonneesFormulaire.Photo.NomFichier) {
        this.messageSnackbar = "Aucun fichier n'a été sélectionné";
        this.snackbar = true;
        return;
      }
      this.uploadFileLoading = false;
      this.$storeDemandeBourse.DonneesFormulaire.Photo.Supprimer = false;
      this.close();
    },
    close() {
      this.dialog.photo = false;
    },
    editItem() {
      this.dialog.photo = true;
    },

    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        // Recupérer la chaine lise dans le data de l'élément en cours
        monFichier.DonneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du ficheir
      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },

    // méthodes on change
    provinceChange() {
      this.$storeDemandeBourse.DonneesFormulaire.RegionMaroc =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.Province,
          this.$storeDemandeBourse.DonneesFormulaire.ProvinceMaroc
        );
    },

    departementChange() {
      this.$storeDemandeBourse.DonneesFormulaire.RegionFrance =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.DepartementFrance,
          this.$storeDemandeBourse.DonneesFormulaire.DepartementFrance
        );
    },

    onEmailChange() {
      this.dialogEmailChange.model = true;
    },
  },
  created() {
    this.$storeDemandeBourse.DonneesFormulaire.PaysAdrPrincipale =
      this.$storeCatalogue.DataId.Maroc;
    this.$storeDemandeBourse.DonneesFormulaire.PaysAutreAdresse =
      this.$storeCatalogue.DataId.France;
  },
  data() {
    return {
      showFrance: true,
      menu: {
        dateNaissance: false,
      },
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeReglesBourse: this.$storeReglesBourse,
      $storeCatalogue: this.$storeCatalogue,
      // icones
      icons: {
        mdiPlusThick,
        mdiDelete,
      },
      // Dialog et flag
      dialog: {
        photo: false,
        propriete: false,
      },
      dialogEmailChange: {
        model: false,
      },
      uploadFileLoading: false,
      snackbar: false,
      messageSnackbar: "Error",
      disabled: false,
      outlined: true,
      clearable: false,
      label:"",
      optionsDH: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },
      optionsEUR: {
        locale: "fr-FR",
        prefix: "EUR",
        suffix: "",
        length: 9,
        precision: 2,
      },
    };
  },
};
</script>
<style scoped src="@/assets/css/Um6pAutresRevenus.css"/>